export const EVENT_CLIENT = 'Event/Live printing';
export const CLIENT_TYPES = ['Artist/Band', 'Brand/Company', 'Starting a clothing brand', EVENT_CLIENT, 'Other'];
export const PRODUCTS = ['T-shirts', 'Hoodies/Sweats', 'Hats', 'Totes', 'Jackets', 'Custom Cut and Sew', 'Other'];
export const DECORATIONS = ['Screen printing', 'Embroidery', 'DTG', 'DTF', 'Sublimation', 'Not sure'];
export const QUANTITIES = ['1–24', '25–49', '50–99', '100–249', '250–499', '500+'];
export const BUDGETS = ['Under $500', '$500–$1,500', '$1,500–$5,000', '$5,000–$15,000', '$15,000+', 'Not sure'];
export const EVENT_TYPES = ['Corporate Event', 'Trade Show', 'Music Festival / Show', 'Brand Activation', 'Private Party', 'University Event', 'Other'];
export const ATTENDANCE_RANGES = ['Under 100', '100–250', '250–500', '500–1,000', '1,000+'];

export const LABEL = 'block text-xs font-semibold uppercase tracking-[0.18em] text-[#00b8ff] mb-2';
export const INPUT =
  'w-full bg-[#0f0f0f] border border-white/10 rounded-lg px-4 py-3 text-[#f4efe6] placeholder:text-[#5a5a5a] focus:outline-none focus:border-[#00b8ff] focus:ring-2 focus:ring-[#00b8ff]/20 transition-colors';

export const INITIAL_QUOTE = {
  name: '', email: '', phone: '', company: '',
  client_type: '', products: [], decoration: [], quantity: '',
  deadline: '', budget: '', details: '', artwork: [],
  event_type: '', event_date: '', attendance: '',
};

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export function validateQuote(f) {
  const e = {};
  if (!f.name.trim()) e.name = 'Required';
  if (!f.email.trim()) e.email = 'Required';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) e.email = 'Invalid email';
  if (!f.client_type) e.client_type = 'Pick one';
  if (!f.products.length) e.products = 'Pick at least one';
  if (!f.decoration.length) e.decoration = 'Pick at least one';
  if (!f.quantity) e.quantity = 'Pick a range';
  if (f.client_type === EVENT_CLIENT) {
    if (!f.event_type) e.event_type = 'Required';
    if (!f.event_date) e.event_date = 'Required';
  }
  if (f.artwork.some((a) => a.status === 'uploading')) e.artwork = 'Wait for uploads to finish';
  return e;
}

export function toPayload(f) {
  const isEvent = f.client_type === EVENT_CLIENT;
  return {
    name: f.name, email: f.email, phone: f.phone, company: f.company,
    client_type: f.client_type, products: f.products, decoration: f.decoration,
    quantity: f.quantity, deadline: f.deadline, budget: f.budget, details: f.details,
    artwork_ids: f.artwork.filter((a) => a.id).map((a) => a.id),
    event_type: isEvent ? f.event_type : '',
    event_date: isEvent ? f.event_date : '',
    attendance: isEvent ? f.attendance : '',
  };
}
